/**
 * @description ファーストビューのYouTube埋め込み
 */
import { isSumaho } from '../common/isSumaho';

export const setMovie = () => {
  if (!$('.js-movie').length) return;

  let ytid = $('.js-movie').data('ytid');
  if (isSumaho()) {
    ytid = $('.js-movie').data('shortid');
  }
  const YTPlayer = require('yt-player');
  const player = new YTPlayer('.js-movie', {
    controls: false,
    caption: false,
    annotations: false,
    modestBranding: true,
    related: false,
  });

  player.load(ytid, true);
  player.mute();
  player.setVolume(0);
  player.on('ended', () => {
    player.play();
  });
};
